// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__oh6mU","wrapper":"Loader_wrapper__px31n"};